import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { AuthContext } from './auth/auth-context';
import { AuthProvider } from './auth/auth-provider';
import { ToastContainer } from './ui/UiToaster';
import Layout from './components/Layout';

import 'overlayscrollbars/overlayscrollbars.css';
import './assets/styles.scss';

const container = document.getElementById('root') as HTMLElement;

const root = ReactDOM.createRoot(container, {
  onUncaughtError(error) {
    console.error('[onUncaughtError]', error);
  },
});

const children = (
  <OverlayScrollbarsComponent
    options={{ scrollbars: { autoHide: 'scroll' } }}
    style={{ height: '100vh' }}
    defer
  >
    <BrowserRouter>
      <AuthProvider context={AuthContext}>
        <Layout />
        <ToastContainer />
      </AuthProvider>
    </BrowserRouter>
  </OverlayScrollbarsComponent>
);

root.render(children);
